(function() { window.GUID_afc069e5_d167_4006_9f11_4bd6afa1795b = { getGuid: function() { return "afc069e5-d167-4006-9f11-4bd6afa1795b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class popupwizard_sportevent_fees_select_players extends Controls.PopupWizardStep {
            constructor() {
                super(...arguments);
                this.NextStep = "select-fees";
            }
            OnCheckIfCanContinue() {
                let checked = this.$StepDiv.find("input:checked");
                return checked.length !== 0;
            }
            OnSubmit() {
                let ids = this.$StepDiv.find("input[name^='player_']:checked").map((i, e) => { return e.name.split('_').pop().split('.'); }).get();
                let $PlayerIds = this.$StepDiv.find("#PlayerIds");
                $PlayerIds.val(ids.join(','));
            }
        }
        Controls.popupwizard_sportevent_fees_select_players = popupwizard_sportevent_fees_select_players;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=select-players.js.map
